import {
  Badge,
  Banner,
  BlockStack,
  Box,
  Button,
  Card,
  Checkbox,
  FormLayout,
  InlineStack,
  Select,
  Text,
} from '@shopify/polaris';
import type { NotificationAudience } from '@/queries/notifications';

const LOGIN_OPTIONS = [
  { label: 'كل المستخدمين', value: 'any' },
  { label: 'الـ Logged in فقط', value: 'logged_in' },
  { label: 'الـ Guests فقط', value: 'guest' },
];

export interface AudienceCardProps {
  includeIos: boolean;
  includeAndroid: boolean;
  includeAr: boolean;
  includeEn: boolean;
  loginStatus: NotificationAudience['login_status'];
  audienceCount: number | null;
  audienceLoading: boolean;
  onIncludeIosChange: (v: boolean) => void;
  onIncludeAndroidChange: (v: boolean) => void;
  onIncludeArChange: (v: boolean) => void;
  onIncludeEnChange: (v: boolean) => void;
  onLoginStatusChange: (v: NotificationAudience['login_status']) => void;
  onRefreshAudienceCount: () => void;
}

export function AudienceCard(props: AudienceCardProps) {
  const {
    includeIos,
    includeAndroid,
    includeAr,
    includeEn,
    loginStatus,
    audienceCount,
    audienceLoading,
    onIncludeIosChange,
    onIncludeAndroidChange,
    onIncludeArChange,
    onIncludeEnChange,
    onLoginStatusChange,
    onRefreshAudienceCount,
  } = props;

  return (
    <Card>
      <BlockStack gap="400">
        <InlineStack align="space-between" blockAlign="center">
          <Text as="h2" variant="headingMd">
            الجمهور
          </Text>
          <InlineStack gap="200" blockAlign="center">
            {audienceCount !== null ? (
              <Badge tone="info">{`${audienceCount} device`}</Badge>
            ) : null}
            <Text as="span" variant="bodySm" tone="subdued">
              الخطوة 3 من 4
            </Text>
          </InlineStack>
        </InlineStack>

        <FormLayout>
          <FormLayout.Group>
            <Box>
              <Text as="p" variant="bodyMd" fontWeight="medium">
                Platforms
              </Text>
              <BlockStack gap="100">
                <Checkbox label="iOS" checked={includeIos} onChange={onIncludeIosChange} />
                <Checkbox label="Android" checked={includeAndroid} onChange={onIncludeAndroidChange} />
              </BlockStack>
            </Box>
            <Box>
              <Text as="p" variant="bodyMd" fontWeight="medium">
                اللغة
              </Text>
              <BlockStack gap="100">
                <Checkbox label="عربي (ar)" checked={includeAr} onChange={onIncludeArChange} />
                <Checkbox label="English (en)" checked={includeEn} onChange={onIncludeEnChange} />
              </BlockStack>
            </Box>
          </FormLayout.Group>

          <Select
            label="حالة الدخول"
            options={LOGIN_OPTIONS}
            value={loginStatus}
            onChange={(v) => onLoginStatusChange(v as NotificationAudience['login_status'])}
          />

          <InlineStack gap="200" blockAlign="center">
            <Button onClick={onRefreshAudienceCount} loading={audienceLoading} variant="plain">
              احسب الوصول المتوقع
            </Button>
            {audienceCount !== null ? (
              <Banner tone="info">
                <p>
                  هيوصل لـ <strong>{audienceCount}</strong> device بالـ filters الحالية.
                </p>
              </Banner>
            ) : null}
          </InlineStack>
        </FormLayout>
      </BlockStack>
    </Card>
  );
}
